var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdviceError = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 12a7 7 0 1 0 14 0 7 7 0 0 0-14 0Zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 12.607a.56.56 0 0 1-.56-.56V7.76a.56.56 0 1 1 1.12 0v4.287c0 .31-.25.56-.56.56Zm0 2.02c.31 0 .56.25.56.56v.013a.56.56 0 1 1-1.12 0v-.014c0-.31.25-.56.56-.56Z",
  fill: "currentColor"
})));
export { SvgAdviceError as ReactComponent };
export default __webpack_public_path__ + "f2b21b42ac008350e7c4ec2c37fc6c40.svg";